module.exports = __webpack_public_path__ + "static/img/egg_animation.587fb2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestival/2/egg_animation.png
// module id = jbpU
// module chunks = 1 9